"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToolbarUploadActionPlugin;

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftExtend = require("draft-extend");

var _UIFileButton = _interopRequireDefault(require("UIComponents/button/UIFileButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var DEFAULT_OPTS = {
  enabled: true,
  tooltip: null,
  multiple: true
};

function getCurrentOptions(options) {
  var currentOptions = options.getCurrentOptions ? options.getCurrentOptions() : {};
  return Object.assign({}, DEFAULT_OPTS, options, currentOptions);
}

function renderInner(options) {
  var icon = options.icon,
      messageKey = options.messageKey;

  if (icon) {
    return _react.default.createElement(_UIIcon.default, {
      name: icon
    });
  } else if (messageKey) {
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: messageKey
    });
  }

  return null;
}

function createActionButton(options) {
  var _this = this;

  var ActionButton = function ActionButton(props) {
    var currentOptions = getCurrentOptions(options);
    var closePopover = props.closePopover;
    var enabled = currentOptions.enabled,
        tooltip = currentOptions.tooltip,
        multiple = currentOptions.multiple;

    var onChange = function onChange() {
      if (currentOptions.onChange) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        currentOptions.onChange.apply(_this, args);
      }

      if (closePopover) {
        closePopover();
      }
    };

    return _react.default.createElement(_UITooltip.default, {
      title: tooltip,
      disabled: !tooltip
    }, _react.default.createElement(_UIFileButton.default, {
      use: "secondary",
      multiple: multiple,
      disabled: !enabled,
      onChange: onChange
    }, renderInner(currentOptions)));
  };

  ActionButton.propTypes = {
    closePopover: _react.PropTypes.func
  };
  return ActionButton;
}

function ToolbarUploadActionPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _draftExtend.createPlugin)({
    displayName: 'ToolbarUploadActionPlugin',
    buttons: createActionButton(opts)
  });
}

module.exports = exports.default;